module.exports = __webpack_public_path__ + "static/img/after-sale-columba-1.ba2faabe.png";